const Banner = () => {
  return (
    <section className="w-full relative h-[530px] flex items-center">
      <div className="h-full w-full absolute z-10">
        <img src="/images/banner1.jpeg" className="absolute w-full h-full object-cover object-center" />
        <div className="w-full h-full bg-black bg-opacity-40 absolute" />
      </div>
      <div className="flex flex-col z-20 relative pl-5 lg:pl-20 gap-2">
        {/* <p className="text-primary text-[15px] font-tommy-regular tracking-wider mb-2 pl-1">Bienvenido a TuVisa360 Peru</p> */}
        <p className="text-white text-[35px] lg:text-[47px] flex flex-row flex-wrap lg:flex-nowrap lg:flex-col leading-10 lg:gap-3 font-tommy-medium">
          <span>CONSEJO DEPARTAMENTAL</span>
          <span>DE DESARROLLO DE HUEHUETENANGO</span>
        </p>
        <a href="https://proyectahuehue.com/sygesdoc" className="bg-primary text-white py-4 px-10 w-max rounded-lg text-lg mt-3 font-tommy-regular hover:bg-red-800 transition-all duration-700" target="_blank">Ingresar al portal</a>
      </div>
    </section>
  );
}

export default Banner;